import React from "react";
import { RxReset } from "react-icons/rx";
import { colorToHex, DEFAULT_FRAME_COLOR } from "../utils";
import useGetLanguage from "../../../../utils/useGetLanguage";
import { LanguageText } from "../../../../dictionary/GroupsText";

interface FrameColorProps {
  color: string;
  onChange: (color: string) => void;
  onReset: () => void;
}

const FrameColor: React.FC<FrameColorProps> = ({ color, onChange, onReset }) => {
  const language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });
  const hexColor = colorToHex(color);

  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center w-full max-w-full min-w-0 bg-white rounded-md sm:rounded-lg p-2 sm:p-3 md:p-4 gap-1.5 sm:gap-0">
      <label className="block text-xs sm:text-sm font-medium mb-1 sm:mb-1.5">
        {language?.groupStyle?.components?.frameColor?.title || "Frame Color"}
      </label>
      <div className="flex items-center sm:ml-auto space-x-1.5 sm:space-x-2 flex-shrink-0">
        <label className="relative cursor-pointer flex items-center">
          <span
            className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 rounded-full border border-gray-300 sm:border-2 flex-shrink-0 flex items-center justify-center shadow-sm"
            style={{ background: color }}
            title="Pick color"
          />
          <input
            type="color"
            value={hexColor}
            onChange={(e) => onChange(e.target.value)}
            className="absolute w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 opacity-0 cursor-pointer"
            style={{ left: 0 }}
            aria-label="Pick color"
          />
        </label>
        {color !== DEFAULT_FRAME_COLOR && (
          <button
            type="button"
            onClick={onReset}
            className="bg-gray-100 text-black rounded-full p-1 sm:p-1.5 hover:text-red-500 hover:bg-gray-200 transition-colors flex-shrink-0"
            aria-label="Reset color"
            title="Reset color"
          >
            <RxReset size={14} className="sm:w-4 sm:h-4 md:w-5 md:h-5" />
          </button>
        )}
      </div>
    </div>
  );
};
export default FrameColor;
